export enum ReviewerType {
  Student = 'student',
  Parent = 'parent',
  Employer = 'employer',
  MissionLocale = 'mission_locale',
  EmploymentCenter = 'employment_center',
  Depository = 'depository',
  Other = 'other',
}
